var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0166 31.3376V83.1265L51.348 82.9582L99.9996 89.449V31.9949L50.0166 31.3376Z",
    fill: "#FAB600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5117V89.449L50.017 83.1265V31.3376L0 31.5117Z",
    fill: "#FECA20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.4489H50.017L57.2186 79.2169L50.017 49.1567L0 89.4489Z",
    fill: "#FAB600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0166 49.1567V89.4489H99.9996L50.0166 49.1567Z",
    fill: "#F59C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.408V31.3376C0 38.5224 3.69844 45.0505 9.86445 48.8009L50.017 73.2212L57.6057 50.3822L50.017 28.408H0Z",
    fill: "#FDE01D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0166 28.408V73.2212L90.1691 48.8009C96.3352 45.0507 99.9996 38.5224 99.9996 31.3376L98.9949 28.408H50.0166Z",
    fill: "#FECA20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9113 13.8521C69.1422 13.8521 61.2227 21.7716 61.2227 31.5407C61.2227 41.3099 69.1422 49.2294 78.9113 49.2294C79.0125 49.2294 79.1129 49.2272 79.2137 49.2255L84.0094 32.0276L79.2137 13.8558C79.1131 13.8542 79.0125 13.8521 78.9113 13.8521Z",
    fill: "#EC6385"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6002 31.5407C96.6002 21.8728 88.8434 14.0175 79.2139 13.856V49.2257C88.8434 49.064 96.6002 41.2089 96.6002 31.5407Z",
    fill: "#E9486F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2135 46.267C76.1541 46.267 73.3076 45.3407 70.9373 43.7557L79.2135 35.4795L81.1191 31.4497L79.2135 27.1959L66.7955 39.6139C65.2105 37.2436 64.2842 34.3971 64.2842 31.3377C64.2842 23.1057 70.9814 16.4084 79.2135 16.4084L81.1191 13.5311L79.2135 10.551C67.7518 10.551 58.4268 19.8758 58.4268 31.3377C58.4268 42.7997 67.7518 52.1245 79.2135 52.1245L82.3715 49.5608L79.2135 46.267Z",
    fill: "#DD2056"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.001 31.3377C100.001 19.8758 90.6756 10.551 79.2139 10.551V16.4084C82.2732 16.4084 85.1197 17.3348 87.49 18.9198L79.2139 27.1959V35.4795L91.6318 23.0616C93.2168 25.4319 94.1432 28.2784 94.1432 31.3377C94.1432 39.5698 87.4459 46.267 79.2139 46.267V52.1245C90.6756 52.1245 100.001 42.7997 100.001 31.3377Z",
    fill: "#C12058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.3bfbc4ae9b46573a2739e88d7711f47c.svg";
export { ForwardRef as ReactComponent };